// FinTrack — Nedeljni izvestaj (upload, parsing, generisanje, renderovanje)
// Napomena: Sav korisnicki unos se eskejpuje pomocu esc() pre renderovanja u DOM

import { state } from './state.js';
import { sb } from './supabase.js';
import { toast, svgIcon, openEditModal, showLoading, hideLoading, showConfirm } from './ui.js';
import { fNum, fNum2, rawNum, cpVal, pNum, pDate, validateExcelColumns, isoLocal } from './utils.js';
import XLSX from 'xlsx-js-style';
import { quickAssign, openGroupingModal } from './crud.js';
import { setUnsavedData } from './nav.js';
import { t, pickLanguage } from './i18n.js';

// MODULE-LOCAL STATE
// parsedData = aktivni (spojeni) skup; parsedData1/2 = po fajlu (nedeljni prima 2 fajla obaveza)
let workbook = null, workbook2 = null, parsedData = [], parsedData1 = [], parsedData2 = [];
let _groupPromptDone = false; // auto-prompt za grupisanje samo jednom po učitanom skupu

// FILE UPLOAD — drag & drop + click
export function initReportUpzone() {
  const uz=document.getElementById('upZone');
  uz.addEventListener('dragover',e=>{e.preventDefault();uz.classList.add('dragover')});
  uz.addEventListener('dragleave',()=>uz.classList.remove('dragover'));
  uz.addEventListener('drop',e=>{e.preventDefault();uz.classList.remove('dragover');if(e.dataTransfer.files.length)procFile(e.dataTransfer.files[0])});
  const uz2=document.getElementById('upZone2');
  if(uz2){
    uz2.addEventListener('dragover',e=>{e.preventDefault();uz2.classList.add('dragover')});
    uz2.addEventListener('dragleave',()=>uz2.classList.remove('dragover'));
    uz2.addEventListener('drop',e=>{e.preventDefault();uz2.classList.remove('dragover');if(e.dataTransfer.files.length)procFile2(e.dataTransfer.files[0])});
  }
}

export function handleFile(i){if(i.files.length){procFile(i.files[0]);i.value='';}}
function procFile(f){
  if(!f.name.match(/\.xlsx?$/i)){toast('Nepodržan format. Koristite .xlsx ili .xls fajl.','err');return;}
  _groupPromptDone=false;
  if(workbook && parsedData.length){toast('Novi fajl učitan — prethodni podaci zamenjeni','warn');}
  const info=document.getElementById('fInfo');
  info.textContent='';
  const sp=document.createElement('span');sp.style.color='var(--acc)';sp.textContent=f.name;info.appendChild(sp);
  const r=new FileReader();r.onload=e=>{
    try{
      workbook=XLSX.read(e.target.result,{type:'array',cellDates:true});
      const sel=document.getElementById('shSel');sel.textContent='';
      workbook.SheetNames.forEach(s=>{const o=document.createElement('option');o.textContent=s;sel.appendChild(o);});
      parseCurrentSheet();
    }catch(err){toast('Greška pri čitanju fajla: '+err.message,'err');}
  };r.readAsArrayBuffer(f)
}
export function parseCurrentSheet(){
  const sn=document.getElementById('shSel').value;if(!workbook||!sn)return;
  const result=parseSheet(workbook.Sheets[sn]);
  if(!result)return;
  parsedData1=result;rebuildMerged();
  const info=document.getElementById('fInfo');
  info.querySelectorAll('.fcnt').forEach(n=>n.remove());
  const sp=document.createElement('span');sp.className='fcnt';sp.style.color='var(--suc)';sp.textContent=' \u2713 '+parsedData1.length+' kom.';info.appendChild(sp);
  // Po prvom u\u010ditavanju pitaj za neispla\u0107ene zarade i porez na imovinu (zasebne kategorije)
  if(state.manualInputs==null)askManualInputs();
}

// Pita za dodatne obaveze (RSD) koje nisu u ERP fajlu: neispla\u0107ene zarade + porez na imovinu.
// Ulaze kao dve zasebne kategorije u dospelo total i u grafikone.
export function askManualInputs(){
  openEditModal('Dodatne obaveze (RSD) \u2014 nisu u Excel fajlu', [
    { label: 'Neispla\u0107ene zarade (RSD)', value: (state.manualInputs&&state.manualInputs.wages)||'0', key: 'wages', type: 'number', step: '0.01' },
    { label: 'Neispla\u0107en porez na imovinu (RSD)', value: (state.manualInputs&&state.manualInputs.propTax)||'0', key: 'propTax', type: 'number', step: '0.01' }
  ], (vals) => {
    state.manualInputs = { wages: parseFloat(vals.wages) || 0, propTax: parseFloat(vals.propTax) || 0 };
    toast('Sa\u010duvano: zarade + porez na imovinu');
    if (state.lastReport) genReport();
  });
}

// DRUGI FAJL (opciono) \u2014 obe datoteke su obaveze, spajaju se u parsedData
export function handleFile2(i){if(i.files.length){procFile2(i.files[0]);i.value='';}}
function procFile2(f){
  if(!f.name.match(/\.xlsx?$/i)){toast('Nepodr\u017ean format. Koristite .xlsx ili .xls fajl.','err');return;}
  _groupPromptDone=false;
  const info=document.getElementById('fInfo2');if(info)info.textContent='';
  if(info){const sp=document.createElement('span');sp.style.color='var(--acc)';sp.textContent=f.name;info.appendChild(sp);}
  const r=new FileReader();r.onload=e=>{
    try{
      workbook2=XLSX.read(e.target.result,{type:'array',cellDates:true});
      const sel=document.getElementById('shSel2');if(sel){sel.textContent='';workbook2.SheetNames.forEach(s=>{const o=document.createElement('option');o.textContent=s;sel.appendChild(o);});}
      parseCurrentSheet2();
    }catch(err){toast('Gre\u0161ka pri \u010ditanju 2. fajla: '+err.message,'err');}
  };r.readAsArrayBuffer(f)
}
export function parseCurrentSheet2(){
  const selEl=document.getElementById('shSel2');const sn=selEl?selEl.value:null;if(!workbook2||!sn)return;
  const result=parseSheet(workbook2.Sheets[sn]);
  if(!result)return;
  parsedData2=result;rebuildMerged();
  const info=document.getElementById('fInfo2');
  if(info){info.querySelectorAll('.fcnt').forEach(n=>n.remove());const sp=document.createElement('span');sp.className='fcnt';sp.style.color='var(--suc)';sp.textContent=' \u2713 '+parsedData2.length+' kom.';info.appendChild(sp);}
}

// Spajanje dva fajla obaveza po komitentu (sabira details + header Dospelo; bez duplikata)
function mergeParsed(a,b){
  if(!b||!b.length)return (a||[]).slice();
  if(!a||!a.length)return (b||[]).slice();
  const keyOf=k=>(k.komitent||'').toLowerCase().replace(/[\xa0\u200b]/g,' ').replace(/\s+/g,' ').trim();
  const out=[];const map=new Map();
  for(const k of a){const c={...k,details:k.details.slice()};map.set(keyOf(k),c);out.push(c);}
  for(const k of b){const key=keyOf(k);const ex=map.get(key);
    if(ex){ex.details=ex.details.concat(k.details);ex._headerDos=(ex._headerDos||0)+(k._headerDos||0);ex.saldo=(ex.saldo||0)+(k.saldo||0);}
    else{const c={...k,details:k.details.slice()};map.set(key,c);out.push(c);}
  }
  return out;
}
function rebuildMerged(){ parsedData = mergeParsed(parsedData1, parsedData2); }

// EXCEL PARSING
function parseSheet(sheet){
  const rows=XLSX.utils.sheet_to_json(sheet,{header:1,raw:true,defval:null});
  if(rows.length<2){toast('Sheet je prazan ili ima samo zaglavlje','err');return false;}
  const hdr=rows[0];

  // Validacija obaveznih kolona
  const missing=validateExcelColumns(hdr,[['komitent'],['rok pla']]);
  if(missing.length){
    toast('Excel nema očekivane kolone: '+missing.join(', ')+'. Proverite format fajla.','err');
    return false;
  }

  const ci=(names)=>{for(const n of names){const i=hdr.findIndex(h=>h&&String(h).trim().toLowerCase().includes(n.toLowerCase()));if(i>=0)return i}return-1};
  const C={kom:ci(['komitent']),saldo:ci(['saldo']),dos:(()=>{const i=hdr.findIndex(h=>h&&/^dospelo$/i.test(String(h).trim()));return i>=0?i:hdr.findIndex(h=>h&&/(?<!ne)dospelo/i.test(String(h).trim()))})(),nd:ci(['nedospelo']),dug:ci(['duguje','dugov']),rok:ci(['rok pla']),dk:ci(['dani ka\u0161','dani kas']),ddok:ci(['datum dokumenta','datum dok']),bd:ci(['broj dokumenta','broj dok'])};
  // Precomputed set of known komitent names (lowercase) — for šifra-prefix stripping
  const _normName=s=>(s||'').toLowerCase().replace(/[\xa0​]/g,' ').replace(/\s+/g,' ').trim();
  const knownNames=new Set(state.komData.map(k=>_normName(k.name)));
  const pd=[];const byName=new Map();let cur=null;
  for(let i=1;i<rows.length;i++){
    const r=rows[i];if(!r||r.every(c=>c==null||c===''))continue;
    const kv=C.kom>=0?r[C.kom]:null;
    let cl=kv?String(kv).replace(/\xa0/g,' ').trim():'';
    // Preskoči total/zbirne redove (npr. "UKUPNO")
    if(cl&&/^(ukupno|ukupan|total|svega|zbir)\b/i.test(cl))continue;
    // Strip leading šifra ("28 Elektroprivreda Srbije" → "Elektroprivreda Srbije") samo ako se očišćeno ime poklapa sa poznatim komitentom
    if(cl){const m=cl.match(/^\d+\s+(.+)$/);if(m&&!knownNames.has(_normName(cl))&&knownNames.has(_normName(m[1])))cl=m[1];}
    if(cl){
      // GRUPISANJE PO IMENU: u ravnom formatu (svaki red = jedna faktura) ime komitenta se ponavlja → spoji u jednu stavku
      const key=_normName(cl);
      cur=byName.get(key);
      if(!cur){const sv=C.saldo>=0?r[C.saldo]:null;cur={komitent:cl,saldo:sv!=null&&sv!==''?pNum(sv):0,details:[],_headerDos:0};byName.set(key,cur);pd.push(cur);}
    }
    if(!cur)continue; // detalj pre prvog komitenta — preskoči
    const rv=C.rok>=0?r[C.rok]:null;
    const dosV=C.dos>=0?pNum(r[C.dos]):0;
    const ndosV=C.nd>=0?pNum(r[C.nd]):0;
    const dkV=C.dk>=0?pNum(r[C.dk]):0;
    const hasBrDok=C.bd>=0&&r[C.bd]!=null&&r[C.bd]!=='';
    const hasDdok=C.ddok>=0&&r[C.ddok]!=null&&r[C.ddok]!=='';
    // Dodaj fakturu kao stavku ako red nosi rok / dokument / iznos (dospelo ili nedospelo)
    if(rv||hasBrDok||hasDdok||Math.abs(dosV)>0.005||Math.abs(ndosV)>0.005){
      cur.details.push({rok:rv?String(rv).trim():'',dos:dosV,ndos:ndosV,dk:dkV});
    }
  }

  if(!pd.length){toast('Nije pronađen nijedan komitent u odabranom sheet-u','err');return false;}

  // AVANSI / PREPLATE: kad zbir detail.dos ne odgovara komitent-header "Dospelo" koloni,
  // razlika je avans/preplata koji ERP drži samo na header nivou (detail red je u "Nedospelo" koloni).
  // Dodaj virtualni red sa tom razlikom da total aplikacije bude jednak header sum-u iz Excel-a.
  for(const k of pd){
    const sumDet=k.details.reduce((s,d)=>s+(d.dos||0),0);
    // Reconciliraj samo kad ERP zaista prijavi header "Dospelo"; ako je header prazan (0),
    // dospeli saldo (npr. jednoredni komitent sa iznosom u Saldo koloni) bi se poništio
    // fantomskim negativnim avansom i potraživanje bi nestalo iz izveštaja.
    const diff=(k._headerDos||0)?((k._headerDos||0)-sumDet):0;
    if(Math.abs(diff)>0.005){
      k.details.push({rok:'Avans',dos:diff,ndos:0,dk:0,_virtual:true});
    }
  }
  return pd;
}

// REPORT GENERATION
export function genReport(){
  if(!parsedData.length){toast('Učitajte Excel fajl','err');return}
  const from=pDate(document.getElementById('dtFrom').value),to=pDate(document.getElementById('dtTo').value);
  let kurs=parseFloat(document.getElementById('kursIn').value);if(!(kurs>0))kurs=100.29;
  if(!from||!to){toast('Unesite oba datuma','err');return}
  if(from>to){toast('Datum "Od" mora biti pre datuma "Do"','err');return}
  // Match by šifra (leading digit prefix) first — ERP assigns stable codes. Fallback to normalized body.
  const extractSifra=s=>{const m=(s||'').match(/^\s*(\d+)\s+/);return m?m[1]:null};
  const normBody=s=>{let x=(s||'').toLowerCase().replace(/[\xa0\u200b]/g,' ').replace(/\s+/g,' ').trim();const m=x.match(/^\d+\s+(.+)$/);return m?m[1]:x};
  const bySifra={},byBody={};
  for(const k of state.komData){const vr=state.vrsteData.find(v=>v.id===k.vrsta_troska_id);if(!vr)continue;const s=extractSifra(k.name);if(s)bySifra[s]=vr.name_en;byBody[normBody(k.name)]=vr.name_en;}
  const lookupKom=name=>{const s=extractSifra(name);if(s&&bySifra[s])return bySifra[s];return byBody[normBody(name)]||null};
  // DOSPELO = sve sa rokom <= izabrani "Do" (ili bez roka ali sa iznosom). Iznos = pun iznos reda
  // (Dospelo + Nedospelo kolona), da ništa ne ispadne kada ERP kolone ne prate izabrani datum.
  const amt=d=>(d.dos||0)+(d.ndos||0);
  const filtered=[];
  for(const k of parsedData){const md=k.details.filter(d=>{if(d._virtual)return true;if(!d.rok)return amt(d)!==0;const rd=pDate(d.rok);return rd?rd<=to:amt(d)!==0;});
  if(md.length>0){const dospelo=md.reduce((s,d)=>s+amt(d),0);filtered.push({...k,details:md.map(d=>({...d})),total:dospelo,dospelo})}}

  if(!filtered.length){toast('Nema podataka za izabrani period','err');return}

  const groups={};for(const v of state.vrsteData)groups[v.name_en]={meta:v,items:[],total:0};groups['_unk']={meta:{name_en:'?',name_sr:'Nepoznati',icon:'\u26A0\uFE0F'},items:[],total:0};
  const unmatched=[];
  for(const k of filtered){const vt=lookupKom(k.komitent)||'_unk';const key=groups[vt]?vt:'_unk';groups[key].items.push(k);groups[key].total+=k.dospelo;if(vt==='_unk')unmatched.push(k.komitent);}
  if(unmatched.length){console.warn('[REPORT] '+unmatched.length+' nekategorisan(ih):',unmatched);console.warn('[REPORT] komData size:',state.komData.length,'| bySifra keys:',Object.keys(bySifra).length,'| byBody keys:',Object.keys(byBody).length);}
  // DEBUG: every line item the report sums — expose on window for CSV export + console dump
  window.__ftDebugRows=[];
  let dbgTotal=0;
  for(const k of filtered){for(const d of k.details){window.__ftDebugRows.push({komitent:k.komitent,rok:d.rok,dospelo:d.dos||0,dk:d.dk||0});dbgTotal+=d.dos||0;}}
  console.log('[REPORT-DEBUG] rows:',window.__ftDebugRows.length,'| sum dospelo:',dbgTotal.toFixed(2));
  console.log('[REPORT-DEBUG] call ftDumpCsv() in console to download CSV, or ftDumpRows() to see array');
  window.ftDumpCsv=()=>{const rows=window.__ftDebugRows||[];const hdr='komitent;rok;dospelo;dk\n';const body=rows.map(r=>'"'+(r.komitent||'').replace(/"/g,'""')+'";'+r.rok+';'+String(r.dospelo).replace('.',',')+';'+r.dk).join('\n');const blob=new Blob(['\uFEFF'+hdr+body],{type:'text/csv;charset=utf-8'});const a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download='report-debug.csv';a.click();URL.revokeObjectURL(a.href);};
  window.ftDumpRows=()=>console.table(window.__ftDebugRows);

  // DODATNE OBAVEZE (ručni unos): neisplaćene zarade + porez na imovinu kao zasebne kategorije (RSD)
  const mi=state.manualInputs;
  if(mi){
    if(mi.wages>0){groups['_payroll']={meta:{name_en:'Payroll (Wages)',name_sr:'Neisplaćene zarade',icon:'👥',_manual:true},items:[{komitent:'Neisplaćene zarade',saldo:mi.wages,details:[{rok:'',dos:mi.wages,ndos:0,dk:0,_manual:true}],total:mi.wages,dospelo:mi.wages}],total:mi.wages};}
    if(mi.propTax>0){groups['_proptax']={meta:{name_en:'Property Tax',name_sr:'Porez na imovinu',icon:'🏛️',_manual:true},items:[{komitent:'Porez na imovinu',saldo:mi.propTax,details:[{rok:'',dos:mi.propTax,ndos:0,dk:0,_manual:true}],total:mi.propTax,dospelo:mi.propTax}],total:mi.propTax};}
  }

  const totalRsd=Object.values(groups).reduce((s,g)=>s+g.total,0);

  // NEDOSPELO: sve stavke u fajlu čiji rok pada POSLE izabranog "Do" datuma — još nije dospelo, ali dospeće.
  // Iznos se čita iz "Nedospelo" kolone (polje ndos iz parsera, NIKAD se ne izmišlja).
  // Dani do dospeća = rok - izabrani "Do" datum (sve vezano za izabrani datum, ne za danas).
  const DAY=86400000;
  const nedGroups={};for(const v of state.vrsteData)nedGroups[v.name_en]={meta:v,items:[],total:0};
  nedGroups['_unk']={meta:{name_en:'?',name_sr:'Nepoznati',icon:'⚠️'},items:[],total:0};
  let nedTotalRsd=0;
  for(const k of parsedData){
    // NEDOSPELO = sve sa rokom > izabrani "Do". Iznos = pun iznos reda (Dospelo+Nedospelo kolona),
    // bez obzira u kojoj je ERP koloni — tako se ništa ne gubi (npr. faktura sa rokom 20.06 a Do 19.06).
    const fut=k.details.filter(d=>{if(d._virtual)return false;if(!d.rok)return false;const rd=pDate(d.rok);return rd&&rd>to;});
    if(!fut.length)continue;
    const ndospelo=fut.reduce((s,d)=>s+amt(d),0);
    if(Math.abs(ndospelo)<0.005)continue;
    // "Dospeva"/dani od najranijeg roka među POZITIVNIM potraživanjima (ne od knjižnog odobrenja)
    const _posFut=fut.filter(d=>amt(d)>0);const _basis=_posFut.length?_posFut:fut;
    let soonest=null;for(const d of _basis){const rd=pDate(d.rok);if(rd&&(!soonest||rd<soonest))soonest=rd;}
    const det=fut.map(d=>{const rd=pDate(d.rok);return{rok:d.rok,ndos:amt(d),days:rd?Math.round((rd-to)/DAY):null};}).sort((a,b)=>(a.days??1e9)-(b.days??1e9));
    const item={komitent:k.komitent,ndospelo,details:det,soonestRok:soonest,soonestRokStr:soonest?soonest.toLocaleDateString('sr-RS'):'',minDays:soonest?Math.round((soonest-to)/DAY):null};
    const vt=lookupKom(k.komitent)||'_unk';const key=nedGroups[vt]?vt:'_unk';
    nedGroups[key].items.push(item);nedGroups[key].total+=ndospelo;nedTotalRsd+=ndospelo;
  }
  const ned={groups:nedGroups,totalRsd:nedTotalRsd,totalUsd:nedTotalRsd/kurs};

  state.lastReport={groups,totalRsd,totalUsd:totalRsd/kurs,kurs,from,to,filtered,ned};
  const _si0=document.getElementById('rSrchInput');if(_si0)_si0.value='';
  renderReport(state.lastReport);
  document.getElementById('rStats').style.display='block';document.getElementById('rSearch').style.display='block';document.getElementById('expBar').style.display='flex';
  // Posle uploada/generisanja: ako ima nekategorisanih, ponudi grupisanje (jednom po skupu)
  if(!_groupPromptDone && groups['_unk'] && groups['_unk'].items.length){ _groupPromptDone=true; setTimeout(()=>openGroupingModal(),350); }
}

// Jedan DOSPELO red — deljeno između inicijalnog prikaza i "Prikaži sve" (da ne drifta wiring)
function buildDospeloRow(k, key, rp, isUnk){
  const kurs=rp.kurs;
  const mx=k.details.length?Math.max(...k.details.map(d=>d.dk)):0;
  const kc=k.dospelo>0?'var(--dng)':'var(--tx3)';
  const row=document.createElement('div');row.className='rkr';row.style.gridTemplateColumns='1fr auto auto auto auto';
  if(isUnk){row.style.cursor='pointer';row.title='Klikni za dodelu kategorije';row.onclick=()=>quickAssign(k.komitent);}
  const c1=document.createElement('div');
  const rkn=document.createElement('div');rkn.className='rkn';
  if(isUnk){const pin=document.createElement('span');pin.style.cssText='color:var(--warn);margin-right:6px;font-size:12px';pin.appendChild(svgIcon('pin',12));rkn.appendChild(pin);}
  rkn.appendChild(document.createTextNode(k.komitent));
  // #6: jasno označi da stavka sadrži avans/preplatu (virtualni red bez roka dospeća)
  if(k.details.some(d=>d._virtual)){const ab=document.createElement('span');ab.style.cssText='margin-left:7px;padding:1px 7px;border-radius:10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;background:rgba(99,152,255,.14);color:var(--acc)';ab.textContent='avans';ab.title='Sadrži avans/preplatu (nema rok dospeća)';rkn.appendChild(ab);}
  const rkd=document.createElement('div');rkd.className='rkd';
  rkd.textContent='Rok: '+k.details.map(d=>d.rok).slice(0,3).join(' | ')+(k.details.length>3?' +'+(k.details.length-3):'');
  c1.appendChild(rkn);c1.appendChild(rkd);
  const c2=document.createElement('div');c2.className='rkrsd';c2.style.color=kc;
  c2.textContent=fNum(k.dospelo)+' ';
  const cp2=document.createElement('button');cp2.className='cpb';cp2.appendChild(svgIcon('clipboard',12));cp2.onclick=e=>{e.stopPropagation();cpVal(rawNum(k.dospelo));};
  c2.appendChild(cp2);
  const c3=document.createElement('div');c3.className='rkusd';c3.style.cssText='font-weight:600;color:var(--tx)';
  c3.textContent=fNum(k.dospelo/kurs)+' ';
  const cp3=document.createElement('button');cp3.className='cpb';cp3.appendChild(svgIcon('clipboard',12));cp3.onclick=e=>{e.stopPropagation();cpVal(rawNum(k.dospelo/kurs));};
  c3.appendChild(cp3);
  const c4=document.createElement('div');c4.className='rkk';
  if(mx>0){const sp=document.createElement('span');sp.className='pbad';sp.textContent=mx+'d';c4.appendChild(sp);}
  else if(mx<0){const sp=document.createElement('span');sp.className='pok';sp.textContent=Math.abs(mx)+'d';c4.appendChild(sp);}
  else{c4.textContent='—';}
  const c5=document.createElement('div');c5.style.cssText='display:flex;gap:4px;align-items:center';
  const btnEd=document.createElement('button');btnEd.className='bico';btnEd.title='Izmeni';btnEd.appendChild(svgIcon('edit',14));
  btnEd.onclick=e=>{e.stopPropagation();editReportItem(k,key,rp);};
  const btnDel=document.createElement('button');btnDel.className='bico del';btnDel.title='Obriši';btnDel.appendChild(svgIcon('trash',14));
  btnDel.onclick=e=>{e.stopPropagation();deleteReportItem(k,key,rp);};
  c5.appendChild(btnEd);c5.appendChild(btnDel);
  row.appendChild(c1);row.appendChild(c2);row.appendChild(c3);row.appendChild(c4);row.appendChild(c5);
  return row;
}

// REPORT RENDERING — uses esc() for all user data before DOM insertion
export function renderReport(rp){
  // Zastareo "Uporedni pregled" postaje nevažeći posle re-generisanja/izmene/brisanja — sakrij ga
  const _co=document.getElementById('compareOut');if(_co){_co.style.display='none';_co.textContent='';}
  const{groups,totalRsd,totalUsd,kurs,from,to,filtered,ned}=rp;const fmt=d=>d.toLocaleDateString('sr-RS');
  // Brojači po SVIM grupama (uključujući sintetičke zarade/porez) da se slažu sa total-om i karticama
  const _kset=new Set();let dC=0;for(const g of Object.values(groups)){for(const it of g.items){_kset.add(it.komitent);dC+=(it.details?it.details.length:0);}}const kC=_kset.size;
  const stBar=document.getElementById('stBar');
  stBar.textContent='';
  const stItems=[{l:'Kurs',v:'1 USD = '+fNum(kurs)+' RSD'},{l:'Dospelo RSD',v:fNum(totalRsd),c:'var(--dng)'},{l:'Dospelo USD',v:fNum(totalUsd),c:'var(--acc)'},{l:'Komit.',v:kC},{l:'Dok.',v:dC}];
  if(ned&&Object.values(ned.groups).some(g=>g.items.length)){stItems.push({l:'Nedospelo RSD',v:fNum(ned.totalRsd),c:'var(--warn)'});stItems.push({l:'Nedospelo USD',v:fNum(ned.totalUsd),c:'var(--warn)'});}
  stItems.forEach(s=>{
    const d=document.createElement('div');d.className='sti';
    const sl=document.createElement('div');sl.className='stl';sl.textContent=s.l;
    const sv=document.createElement('div');sv.className='stv';sv.textContent=s.v;if(s.c)sv.style.color=s.c;
    d.appendChild(sl);d.appendChild(sv);stBar.appendChild(d);
  });
  const out=document.getElementById('rOut');
  // Build report using DOM API for safety — complex nested structure
  out.textContent='';
  let gi=0;
  for(const[key,g] of Object.entries(groups)){
    if(!g.items.length)continue;
    const clr=g.total>0?'var(--dng)':'var(--tx3)';
    const bc=key==='_unk'?'var(--warn)':'var(--acc)';
    const isUnk=key==='_unk';

    const grp=document.createElement('div');grp.className='rgrp'+(gi===0||isUnk?' open':'');grp.id='rg-'+gi;

    // Header
    const gh=document.createElement('div');gh.className='rgh';gh.style.borderTop='2px solid '+bc;gh.onclick=(idx=>()=>tgGrp(idx))(gi);
    const gl=document.createElement('div');gl.className='rgl';
    const gIcon=document.createElement('span');gIcon.className='rgi';gIcon.textContent=g.meta.icon;
    const gn=document.createElement('div');gn.className='rgn';
    const gh3=document.createElement('h3');gh3.textContent=g.meta.name_en+(g.meta.name_sr?' \u2014 '+g.meta.name_sr:'');
    const gSub=document.createElement('span');gSub.textContent=g.items.length+' kom. \u00B7 '+g.items.reduce((s,k)=>s+k.details.length,0)+' dok.';
    gn.appendChild(gh3);gn.appendChild(gSub);gl.appendChild(gIcon);gl.appendChild(gn);

    const grWrap=document.createElement('div');grWrap.style.cssText='display:flex;align-items:center';
    const gr=document.createElement('div');gr.className='rgr';
    const gAmt=document.createElement('div');gAmt.className='rga';gAmt.style.color=clr;
    gAmt.textContent=fNum(g.total)+' RSD ';
    const cpb=document.createElement('button');cpb.className='cpb';cpb.appendChild(svgIcon('clipboard',12));cpb.title='Kopiraj';
    cpb.onclick=e=>{e.stopPropagation();cpVal(rawNum(g.total));};
    gAmt.appendChild(cpb);
    const gUsd=document.createElement('div');gUsd.className='rgau';gUsd.textContent=fNum(g.total/kurs)+' USD';
    gr.appendChild(gAmt);gr.appendChild(gUsd);
    const chev=document.createElement('span');chev.className='rgch';chev.textContent='\u25BC';
    grWrap.appendChild(gr);grWrap.appendChild(chev);
    gh.appendChild(gl);gh.appendChild(grWrap);

    // Body
    const gb=document.createElement('div');gb.className='rgb';

    if(isUnk){
      const ub=document.createElement('div');ub.style.cssText='padding:12px 22px;background:rgba(255,181,71,.06);border-bottom:1px solid rgba(255,181,71,.15);display:flex;align-items:center;justify-content:space-between';
      const ubL=document.createElement('div');ubL.style.cssText='display:flex;align-items:center;gap:8px';
      const ubIcon=document.createElement('span');ubIcon.style.fontSize='16px';ubIcon.appendChild(svgIcon('warning',16));
      const ubText=document.createElement('span');ubText.style.cssText='font-size:13px;color:var(--warn);font-weight:600';
      ubText.textContent=g.items.length+' nekategoriz. komitent(a) \u2014 Ukupno: '+fNum(g.total)+' RSD';
      ubL.appendChild(ubIcon);ubL.appendChild(ubText);
      const ubR=document.createElement('button');ubR.className='bsm';ubR.style.cssText='font-size:12px';ubR.textContent='Grupiši sve →';ubR.title='Dodeli kategorije svim nekategorisanim odjednom';ubR.onclick=()=>openGroupingModal();
      ub.appendChild(ubL);ub.appendChild(ubR);gb.appendChild(ub);
    }

    // Column headers
    const rcol=document.createElement('div');rcol.className='rcol';rcol.style.gridTemplateColumns='1fr auto auto auto auto';
    ['Komitent','Dospelo (RSD)','Dospelo (USD)','Ka\u0161nj.',''].forEach(t=>{const d=document.createElement('div');d.textContent=t;rcol.appendChild(d);});
    gb.appendChild(rcol);

    // Rows
    const REPORT_PAGE_SIZE = 50;
    const sortedItems = g.items.sort((a,b)=>b.dospelo-a.dospelo);
    const showAll = sortedItems.length <= REPORT_PAGE_SIZE;
    const visibleItems = showAll ? sortedItems : sortedItems.slice(0, REPORT_PAGE_SIZE);

    visibleItems.forEach(k=>{
      const mx=k.details.length?Math.max(...k.details.map(d=>d.dk)):0;
      const kc=k.dospelo>0?'var(--dng)':'var(--tx3)';
      const row=document.createElement('div');row.className='rkr';row.style.gridTemplateColumns='1fr auto auto auto auto';
      if(isUnk){row.style.cursor='pointer';row.title='Klikni za dodelu kategorije';row.onclick=()=>quickAssign(k.komitent);}

      const c1=document.createElement('div');
      const rkn=document.createElement('div');rkn.className='rkn';
      if(isUnk){const pin=document.createElement('span');pin.style.cssText='color:var(--warn);margin-right:6px;font-size:12px';pin.appendChild(svgIcon('pin',12));rkn.appendChild(pin);}
      rkn.appendChild(document.createTextNode(k.komitent));
      if(k.details.some(d=>d._virtual)){const ab=document.createElement('span');ab.style.cssText='margin-left:7px;padding:1px 7px;border-radius:10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;background:rgba(99,152,255,.14);color:var(--acc)';ab.textContent='avans';ab.title='Sadrži avans/preplatu (nema rok dospeća)';rkn.appendChild(ab);}
      const rkd=document.createElement('div');rkd.className='rkd';
      rkd.textContent='Rok: '+k.details.map(d=>d.rok).slice(0,3).join(' | ')+(k.details.length>3?' +'+(k.details.length-3):'');
      c1.appendChild(rkn);c1.appendChild(rkd);

      const c2=document.createElement('div');c2.className='rkrsd';c2.style.color=kc;
      c2.textContent=fNum(k.dospelo)+' ';
      const cp2=document.createElement('button');cp2.className='cpb';cp2.appendChild(svgIcon('clipboard',12));cp2.onclick=e=>{e.stopPropagation();cpVal(rawNum(k.dospelo));};
      c2.appendChild(cp2);

      const c3=document.createElement('div');c3.className='rkusd';c3.style.cssText='font-weight:600;color:var(--tx)';
      c3.textContent=fNum(k.dospelo/kurs)+' ';
      const cp3=document.createElement('button');cp3.className='cpb';cp3.appendChild(svgIcon('clipboard',12));cp3.onclick=e=>{e.stopPropagation();cpVal(rawNum(k.dospelo/kurs));};
      c3.appendChild(cp3);

      const c4=document.createElement('div');c4.className='rkk';
      if(mx>0){const sp=document.createElement('span');sp.className='pbad';sp.textContent=mx+'d';c4.appendChild(sp);}
      else if(mx<0){const sp=document.createElement('span');sp.className='pok';sp.textContent=Math.abs(mx)+'d';c4.appendChild(sp);}
      else{c4.textContent='\u2014';}

      // Akcije: edit + delete
      const c5=document.createElement('div');c5.style.cssText='display:flex;gap:4px;align-items:center';
      const btnEd=document.createElement('button');btnEd.className='bico';btnEd.title='Izmeni';btnEd.appendChild(svgIcon('edit',14));
      btnEd.onclick=e=>{e.stopPropagation();editReportItem(k,key,rp);};
      const btnDel=document.createElement('button');btnDel.className='bico del';btnDel.title='Obriši';btnDel.appendChild(svgIcon('trash',14));
      btnDel.onclick=e=>{e.stopPropagation();deleteReportItem(k,key,rp);};
      c5.appendChild(btnEd);c5.appendChild(btnDel);

      row.appendChild(c1);row.appendChild(c2);row.appendChild(c3);row.appendChild(c4);row.appendChild(c5);
      gb.appendChild(row);
    });

    // "Prikaži sve" dugme ako ima više od 50 komitenata
    if (!showAll) {
      const moreBar = document.createElement('div');
      moreBar.style.cssText = 'padding:12px 22px;text-align:center;border-top:1px solid var(--border)';
      const moreBtn = document.createElement('button');
      moreBtn.className = 'bsm rmore';
      moreBtn.style.cssText = 'font-size:12px';
      moreBtn.textContent = 'Prikaži sve (' + sortedItems.length + ' komitenata)';
      moreBtn.onclick = () => {
        sortedItems.slice(REPORT_PAGE_SIZE).forEach(k => { gb.insertBefore(buildDospeloRow(k,key,rp,isUnk), moreBar); });
        moreBar.remove();
        if(false)sortedItems.slice(REPORT_PAGE_SIZE).forEach(k => {
          const mx=k.details.length?Math.max(...k.details.map(d=>d.dk)):0;
          const kc=k.dospelo>0?'var(--dng)':'var(--tx3)';
          const row=document.createElement('div');row.className='rkr';row.style.gridTemplateColumns='1fr auto auto auto auto';
          const c1=document.createElement('div');
          const rkn=document.createElement('div');rkn.className='rkn';rkn.textContent=k.komitent;
          const rkd=document.createElement('div');rkd.className='rkd';rkd.textContent='Rok: '+k.details.map(d=>d.rok).slice(0,3).join(' | ');
          c1.appendChild(rkn);c1.appendChild(rkd);
          const c2=document.createElement('div');c2.className='rkrsd';c2.style.color=kc;c2.textContent=fNum(k.dospelo);
          const c3=document.createElement('div');c3.className='rkusd';c3.textContent=fNum(k.dospelo/kurs);
          const c4=document.createElement('div');c4.className='rkk';
          if(mx>0){const sp=document.createElement('span');sp.className='pbad';sp.textContent=mx+'d';c4.appendChild(sp);}
          else{c4.textContent='\u2014';}
          const c5=document.createElement('div');c5.style.cssText='display:flex;gap:4px;align-items:center';
          const btnEd2=document.createElement('button');btnEd2.className='bico';btnEd2.title='Izmeni';btnEd2.appendChild(svgIcon('edit',14));
          btnEd2.onclick=e=>{e.stopPropagation();editReportItem(k,key,rp);};
          const btnDel2=document.createElement('button');btnDel2.className='bico del';btnDel2.title='Obriši';btnDel2.appendChild(svgIcon('trash',14));
          btnDel2.onclick=e=>{e.stopPropagation();deleteReportItem(k,key,rp);};
          c5.appendChild(btnEd2);c5.appendChild(btnDel2);
          row.appendChild(c1);row.appendChild(c2);row.appendChild(c3);row.appendChild(c4);row.appendChild(c5);
          gb.insertBefore(row, moreBar);
        });
      };
      moreBar.appendChild(moreBtn);
      gb.appendChild(moreBar);
    }

    grp.appendChild(gh);grp.appendChild(gb);out.appendChild(grp);gi++;
  }

  // Total card
  const tc=document.createElement('div');tc.className='tcard';
  const tcL=document.createElement('div');
  const tLbl=document.createElement('div');tLbl.className='tlbl';tLbl.textContent='TOTAL OPEX';
  const tPer=document.createElement('div');tPer.style.cssText='font-size:12px;color:var(--tx3)';tPer.textContent=fmt(from)+' \u2013 '+fmt(to);
  tcL.appendChild(tLbl);tcL.appendChild(tPer);
  const tcR=document.createElement('div');tcR.style.textAlign='right';
  const tRsd=document.createElement('div');tRsd.className='trsd';tRsd.textContent=fNum(totalRsd)+' RSD';
  const tUsd=document.createElement('div');tUsd.className='tusd';tUsd.textContent=fNum(totalUsd)+' USD';
  tcR.appendChild(tRsd);tcR.appendChild(tUsd);
  tc.appendChild(tcL);tc.appendChild(tcR);out.appendChild(tc);

  renderNedospelo(rp,out);
  // Zadrži aktivnu pretragu posle re-rendera (izmena/brisanje)
  const _si=document.getElementById('rSrchInput');if(_si&&_si.value)filterReportDisplay();
}

// NEDOSPELO RENDER — druga sekcija: sve što još nije dospelo, grupisano po kategoriji
function renderNedospelo(rp,out){
  const ned=rp.ned,kurs=rp.kurs,to=rp.to;
  if(!ned||!Object.values(ned.groups).some(g=>g.items.length))return;
  const fmt=d=>d.toLocaleDateString('sr-RS');

  // Section divider / header
  const sec=document.createElement('div');sec.className='card';sec.style.cssText='margin:28px 0 12px;padding:16px 18px;border-left:3px solid var(--warn)';
  const sh=document.createElement('div');sh.style.cssText='display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px';
  const shL=document.createElement('div');
  const shT=document.createElement('h2');shT.style.cssText='font-size:16px;color:var(--warn)';shT.textContent='JOŠ NIJE DOSPELO';
  const shS=document.createElement('div');shS.style.cssText='font-size:12px;color:var(--tx3)';shS.textContent='Dospeće nakon '+fmt(to)+' · dani do dospeća od izabranog datuma';
  shL.appendChild(shT);shL.appendChild(shS);
  const shR=document.createElement('div');shR.style.textAlign='right';
  const shRsd=document.createElement('div');shRsd.style.cssText='font-family:var(--mn);font-weight:700;color:var(--warn);font-size:16px';shRsd.textContent=fNum(ned.totalRsd)+' RSD';
  const shUsd=document.createElement('div');shUsd.style.cssText='font-family:var(--mn);color:var(--tx3);font-size:12px';shUsd.textContent=fNum(ned.totalUsd)+' USD';
  shR.appendChild(shRsd);shR.appendChild(shUsd);
  sh.appendChild(shL);sh.appendChild(shR);sec.appendChild(sh);out.appendChild(sec);

  let gi=0;
  for(const[key,g] of Object.entries(ned.groups)){
    if(!g.items.length)continue;
    const isUnk=key==='_unk';
    const bc=isUnk?'var(--warn)':'var(--acc)';
    const grp=document.createElement('div');grp.className='rgrp'+(gi===0||isUnk?' open':'');

    const gh=document.createElement('div');gh.className='rgh';gh.style.borderTop='2px solid '+bc;gh.style.cursor='pointer';gh.onclick=()=>grp.classList.toggle('open');
    const gl=document.createElement('div');gl.className='rgl';
    const gIcon=document.createElement('span');gIcon.className='rgi';gIcon.textContent=g.meta.icon;
    const gn=document.createElement('div');gn.className='rgn';
    const gh3=document.createElement('h3');gh3.textContent=g.meta.name_en+(g.meta.name_sr?' — '+g.meta.name_sr:'');
    const gSub=document.createElement('span');gSub.textContent=g.items.length+' kom. · '+g.items.reduce((s,k)=>s+k.details.length,0)+' dok.';
    gn.appendChild(gh3);gn.appendChild(gSub);gl.appendChild(gIcon);gl.appendChild(gn);
    const grWrap=document.createElement('div');grWrap.style.cssText='display:flex;align-items:center';
    const gr=document.createElement('div');gr.className='rgr';
    const gAmt=document.createElement('div');gAmt.className='rga';gAmt.style.color='var(--warn)';gAmt.textContent=fNum(g.total)+' RSD ';
    const cpb=document.createElement('button');cpb.className='cpb';cpb.appendChild(svgIcon('clipboard',12));cpb.title='Kopiraj';cpb.onclick=e=>{e.stopPropagation();cpVal(rawNum(g.total));};
    gAmt.appendChild(cpb);
    const gUsd=document.createElement('div');gUsd.className='rgau';gUsd.textContent=fNum(g.total/kurs)+' USD';
    gr.appendChild(gAmt);gr.appendChild(gUsd);
    const chev=document.createElement('span');chev.className='rgch';chev.textContent='▼';
    grWrap.appendChild(gr);grWrap.appendChild(chev);
    gh.appendChild(gl);gh.appendChild(grWrap);

    const gb=document.createElement('div');gb.className='rgb';
    const rcol=document.createElement('div');rcol.className='rcol';rcol.style.gridTemplateColumns='1fr auto auto auto auto auto';
    ['Komitent','Nedospelo (RSD)','Nedospelo (USD)','Dospeva','za',''].forEach(t=>{const d=document.createElement('div');d.textContent=t;rcol.appendChild(d);});
    gb.appendChild(rcol);

    g.items.sort((a,b)=>(a.minDays??1e9)-(b.minDays??1e9)).forEach(k=>{
      const row=document.createElement('div');row.className='rkr';row.style.gridTemplateColumns='1fr auto auto auto auto auto';
      if(isUnk){row.style.cursor='pointer';row.title='Klikni za dodelu kategorije';row.onclick=()=>quickAssign(k.komitent);}
      const c1=document.createElement('div');
      const rkn=document.createElement('div');rkn.className='rkn';
      if(isUnk){const pin=document.createElement('span');pin.style.cssText='color:var(--warn);margin-right:6px;font-size:12px';pin.appendChild(svgIcon('pin',12));rkn.appendChild(pin);}
      rkn.appendChild(document.createTextNode(k.komitent));
      if(k.details.some(d=>d._virtual)){const ab=document.createElement('span');ab.style.cssText='margin-left:7px;padding:1px 7px;border-radius:10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;background:rgba(99,152,255,.14);color:var(--acc)';ab.textContent='avans';ab.title='Sadrži avans/preplatu (nema rok dospeća)';rkn.appendChild(ab);}
      const rkd=document.createElement('div');rkd.className='rkd';
      rkd.textContent='Rok: '+k.details.map(d=>d.rok).slice(0,3).join(' | ')+(k.details.length>3?' +'+(k.details.length-3):'');
      c1.appendChild(rkn);c1.appendChild(rkd);
      const c2=document.createElement('div');c2.className='rkrsd';c2.style.color='var(--warn)';c2.textContent=fNum(k.ndospelo)+' ';
      const cp2=document.createElement('button');cp2.className='cpb';cp2.appendChild(svgIcon('clipboard',12));cp2.onclick=e=>{e.stopPropagation();cpVal(rawNum(k.ndospelo));};c2.appendChild(cp2);
      const c3=document.createElement('div');c3.className='rkusd';c3.style.cssText='font-weight:600;color:var(--tx)';c3.textContent=fNum(k.ndospelo/kurs)+' ';
      const cp3=document.createElement('button');cp3.className='cpb';cp3.appendChild(svgIcon('clipboard',12));cp3.onclick=e=>{e.stopPropagation();cpVal(rawNum(k.ndospelo/kurs));};c3.appendChild(cp3);
      const c4=document.createElement('div');c4.style.cssText='font-size:12px;color:var(--tx2);white-space:nowrap';c4.textContent=k.soonestRokStr||'—';
      const c5=document.createElement('div');
      const days=k.minDays;const sp=document.createElement('span');
      if(days==null){sp.textContent='—';}
      else if(days>0){sp.style.cssText='display:inline-block;padding:3px 9px;border-radius:12px;font-family:var(--mn);font-size:12px;font-weight:700;background:var(--suc-bg);color:var(--suc)';sp.textContent='za '+days+'d';}
      else if(days===0){sp.style.cssText='display:inline-block;padding:3px 9px;border-radius:12px;font-family:var(--mn);font-size:12px;font-weight:700;background:rgba(255,181,71,.12);color:var(--warn)';sp.textContent='danas';}
      else{sp.style.cssText='display:inline-block;padding:3px 9px;border-radius:12px;font-family:var(--mn);font-size:12px;font-weight:700;background:var(--dng-bg);color:var(--dng)';sp.textContent=Math.abs(days)+'d ranije';}
      c5.appendChild(sp);
      // Akcije: edit + delete
      const c6=document.createElement('div');c6.style.cssText='display:flex;gap:4px;align-items:center';
      const btnEd=document.createElement('button');btnEd.className='bico';btnEd.title='Izmeni';btnEd.appendChild(svgIcon('edit',14));
      btnEd.onclick=e=>{e.stopPropagation();editNedospeloItem(k,key,rp);};
      const btnDel=document.createElement('button');btnDel.className='bico del';btnDel.title='Obriši';btnDel.appendChild(svgIcon('trash',14));
      btnDel.onclick=e=>{e.stopPropagation();deleteNedospeloItem(k,key,rp);};
      c6.appendChild(btnEd);c6.appendChild(btnDel);
      row.appendChild(c1);row.appendChild(c2);row.appendChild(c3);row.appendChild(c4);row.appendChild(c5);row.appendChild(c6);
      gb.appendChild(row);
    });
    grp.appendChild(gh);grp.appendChild(gb);out.appendChild(grp);gi++;
  }

  const tc=document.createElement('div');tc.className='tcard';tc.style.borderColor='var(--warn)';
  const tcL=document.createElement('div');
  const tLbl=document.createElement('div');tLbl.className='tlbl';tLbl.textContent='TOTAL NEDOSPELO';
  const tPer=document.createElement('div');tPer.style.cssText='font-size:12px;color:var(--tx3)';tPer.textContent='Dospeće nakon '+fmt(to);
  tcL.appendChild(tLbl);tcL.appendChild(tPer);
  const tcR=document.createElement('div');tcR.style.textAlign='right';
  const tRsd=document.createElement('div');tRsd.className='trsd';tRsd.style.color='var(--warn)';tRsd.textContent=fNum(ned.totalRsd)+' RSD';
  const tUsd=document.createElement('div');tUsd.className='tusd';tUsd.textContent=fNum(ned.totalUsd)+' USD';
  tcR.appendChild(tRsd);tcR.appendChild(tUsd);
  tc.appendChild(tcL);tc.appendChild(tcR);out.appendChild(tc);
}
// ============================================================
// EDIT / DELETE / SAVE za nedeljni izveštaj
// ============================================================
function editReportItem(item, groupKey, rp) {
  openEditModal('Izmeni iznos: ' + item.komitent, [
    { label: 'Dospelo (RSD)', value: item.dospelo || '0', key: 'dospelo', type: 'number', step: '0.01' }
  ], (vals) => {
    const val = parseFloat(vals.dospelo) || 0;
    const oldVal = item.dospelo;
    item.dospelo = val; item.total = val;
    // Uskladi pojedinačne redove sa novim iznosom (da sačuvani/eksportovani detalji zbrajaju tačno)
    if (Math.abs(oldVal) > 0.005) { const _f = val / oldVal; item.details.forEach(d => { if (typeof d.dos === 'number') d.dos *= _f; }); }
    // Sintetičke kategorije (zarade/porez): upiši nazad u manualInputs da re-generisanje ne vrati staru vrednost
    if (groupKey === '_payroll' && state.manualInputs) state.manualInputs.wages = val;
    if (groupKey === '_proptax' && state.manualInputs) state.manualInputs.propTax = val;
    const g = rp.groups[groupKey];
    if (g) g.total = g.total - oldVal + val;
    rp.totalRsd = Object.values(rp.groups).reduce((s, gr) => s + gr.total, 0);
    rp.totalUsd = rp.totalRsd / rp.kurs;
    renderReport(rp);
    setUnsavedData(true);
    toast('Iznos izmenjen');
  });
}

function deleteReportItem(item, groupKey, rp) {
  showConfirm('Obrisati ' + item.komitent + ' (' + fNum(item.dospelo) + ' RSD)?', () => {
  const g = rp.groups[groupKey];
  if (g) {
    const idx = g.items.indexOf(item);
    if (idx >= 0) { g.total -= item.dospelo; g.items.splice(idx, 1); }
  }
  const fi = rp.filtered.indexOf(item);
  if (fi >= 0) rp.filtered.splice(fi, 1);
  // Sintetičke kategorije (zarade/porez): nuluj manualInputs da se NE vrate pri re-generisanju
  if (groupKey === '_payroll' && state.manualInputs) state.manualInputs.wages = 0;
  if (groupKey === '_proptax' && state.manualInputs) state.manualInputs.propTax = 0;
  rp.totalRsd = Object.values(rp.groups).reduce((s, gr) => s + gr.total, 0);
  rp.totalUsd = rp.totalRsd / rp.kurs;
  renderReport(rp);
  setUnsavedData(true);
  toast('Stavka obrisana');
  });
}

// EDIT / DELETE za NEDOSPELO stavke
function editNedospeloItem(item, groupKey, rp) {
  openEditModal('Izmeni nedospelo: ' + item.komitent, [
    { label: 'Nedospelo (RSD)', value: item.ndospelo || '0', key: 'ndospelo', type: 'number', step: '0.01' }
  ], (vals) => {
    const val = parseFloat(vals.ndospelo) || 0;
    const oldVal = item.ndospelo;
    item.ndospelo = val;
    if (Math.abs(oldVal) > 0.005) { const _f = val / oldVal; item.details.forEach(d => { if (typeof d.ndos === 'number') d.ndos *= _f; }); }
    const g = rp.ned.groups[groupKey];
    if (g) g.total = g.total - oldVal + val;
    rp.ned.totalRsd = Object.values(rp.ned.groups).reduce((s, gr) => s + gr.total, 0);
    rp.ned.totalUsd = rp.ned.totalRsd / rp.kurs;
    renderReport(rp);
    setUnsavedData(true);
    toast('Iznos izmenjen');
  });
}

function deleteNedospeloItem(item, groupKey, rp) {
  showConfirm('Obrisati ' + item.komitent + ' (' + fNum(item.ndospelo) + ' RSD, nedospelo)?', () => {
    const g = rp.ned.groups[groupKey];
    if (g) {
      const idx = g.items.indexOf(item);
      if (idx >= 0) { g.total -= item.ndospelo; g.items.splice(idx, 1); }
    }
    rp.ned.totalRsd = Object.values(rp.ned.groups).reduce((s, gr) => s + gr.total, 0);
    rp.ned.totalUsd = rp.ned.totalRsd / rp.kurs;
    renderReport(rp);
    setUnsavedData(true);
    toast('Stavka obrisana');
  });
}

// Clear all report data — "Počni ponovo" button
export function clearReportData() {
  showConfirm('Obrisati sve učitane podatke i početi ponovo?', () => {
  workbook = null; workbook2 = null;
  parsedData = []; parsedData1 = []; parsedData2 = [];
  state.manualInputs = null;
  state.lastReport = null;
  setUnsavedData(false);
  const _fi = document.getElementById('fInput'); if (_fi) _fi.value = '';
  const _fi2 = document.getElementById('fInput2'); if (_fi2) _fi2.value = '';
  const _si = document.getElementById('rSrchInput'); if (_si) _si.value = '';
  document.getElementById('fInfo').textContent = '';
  const _fi2info = document.getElementById('fInfo2'); if (_fi2info) _fi2info.textContent = '';
  const _sh2 = document.getElementById('shSel2'); if (_sh2) _sh2.textContent = '';
  document.getElementById('shSel').textContent = '';
  document.getElementById('rOut').textContent = '';
  document.getElementById('rStats').style.display = 'none';
  document.getElementById('rSearch').style.display = 'none';
  document.getElementById('expBar').style.display = 'none';
  const co = document.getElementById('compareOut');
  if (co) { co.style.display = 'none'; co.textContent = ''; }
  toast('Podaci obrisani');
  });
}

// DASHBOARD PDF (grafikoni) — profesionalni vizuelni izveštaj obaveza, dvojezično
export async function expDashboardPdf() {
  if (!state.lastReport) { toast('Generišite izveštaj prvo', 'err'); return; }
  const lang = await pickLanguage('sr');
  if (!lang) return;
  showLoading();
  try {
    const { buildDashboardPdf, donutConfig, hbarConfig, barConfig, SERIES } = await import('./chart-pdf.js');
    const rp = state.lastReport, kurs = rp.kurs;
    // Valuta prati jezik: srpski PDF = RSD, engleski PDF = USD (bez druge valute)
    const isEn = lang === 'en';
    const CUR = isEn ? 'USD' : 'RSD';
    const cv = v => isEn ? v / kurs : v;        // iznos u prikaznoj valuti
    const money = v => fNum2(cv(v));            // tačan iznos sa 2 decimale (kao u Excelu)
    const fmt = d => d.toLocaleDateString(lang === 'en' ? 'en-GB' : 'sr-RS');
    const nm = g => g.meta && g.meta._manual ? (lang === 'en' ? g.meta.name_en : g.meta.name_sr) : '';
    // Kategorije (dospelo)
    const cats = [];
    for (const [key, g] of Object.entries(rp.groups)) {
      if (!g.items.length) continue;
      const name = key === '_unk' ? t('uncategorized', lang) : (lang === 'en' ? (g.meta.name_en || g.meta.name_sr) : (g.meta.name_sr || g.meta.name_en));
      cats.push({ key, name, total: g.total });
    }
    cats.sort((a, b) => b.total - a.total);
    const grand = cats.reduce((s, c) => s + c.total, 0);
    const nedTotal = rp.ned ? rp.ned.totalRsd : 0;
    const totalLia = grand + nedTotal;
    // Top stavke (dospelo)
    const allItems = [];
    for (const g of Object.values(rp.groups)) for (const it of g.items) allItems.push(it);
    allItems.sort((a, b) => b.dospelo - a.dospelo);
    const top = allItems.slice(0, 10);
    // Aging buckets po danima kašnjenja (RSD) — za prikaz rizika
    const buckets = [
      { l: lang === 'en' ? 'On time/≤0' : 'U roku/≤0', max: 0, c: '#227846', v: 0 },
      { l: '1–30', max: 30, c: '#c19a40', v: 0 },
      { l: '31–60', max: 60, c: '#e0884a', v: 0 },
      { l: '61–90', max: 90, c: '#d9734a', v: 0 },
      { l: '90+', max: 1e9, c: '#c94048', v: 0 },
    ];
    for (const it of allItems) {
      const mx = it.details && it.details.length ? Math.max(...it.details.map(d => d.dk || 0)) : 0;
      const b = buckets.find(b => mx <= b.max) || buckets[buckets.length - 1];
      b.v += it.dospelo || 0;
    }
    // Predstojeća dospeća (nedospelo)
    const nedItems = [];
    if (rp.ned) for (const g of Object.values(rp.ned.groups)) for (const it of g.items) nedItems.push(it);
    nedItems.sort((a, b) => (a.minDays ?? 1e9) - (b.minDays ?? 1e9));
    const up = nedItems.slice(0, 8);

    const pct = v => totalLia > 0 ? ((v / totalLia) * 100).toFixed(1) + '% ' + t('of_total', lang) : '';
    const short = v => { const a = Math.abs(v); if (a >= 1e6) return (v / 1e6).toFixed(1) + 'M'; if (a >= 1e3) return Math.round(v / 1e3) + 'K'; return String(Math.round(v)); };
    const k90 = buckets[buckets.length - 1].v;            // kašnjenje 90+ (RSD)
    const komBroj = allItems.length;                       // broj komitenata (dospelo)
    const kpis = [
      { label: t('total_liabilities', lang), value: money(totalLia) + ' ' + CUR, sub: '', color: 'green' },
      { label: t('past_due', lang), value: money(grand) + ' ' + CUR, sub: pct(grand), color: 'red' },
      { label: t('upcoming', lang), value: money(nedTotal) + ' ' + CUR, sub: pct(nedTotal), color: 'amber' },
      { label: t('severely_overdue', lang), value: money(k90) + ' ' + CUR, sub: pct(k90), color: 'red' },
      { label: t('largest_category', lang), value: cats[0] ? cats[0].name : '—', sub: cats[0] ? money(cats[0].total) + ' ' + CUR : '', color: 'green' },
      { label: t('counterparties', lang), value: String(komBroj), sub: t('past_due', lang), color: 'green' },
    ];
    // Manuelne stavke (zarade/porez) kao zasebne KPI kartice — uvek vidljive
    const mi = state.manualInputs || {};
    if (mi.wages > 0) kpis.push({ label: t('payroll_wages', lang), value: money(mi.wages) + ' ' + CUR, sub: pct(mi.wages), color: 'amber' });
    if (mi.propTax > 0) kpis.push({ label: t('property_tax', lang), value: money(mi.propTax) + ' ' + CUR, sub: pct(mi.propTax), color: 'amber' });
    // Kategorijski bar: top-8 + uvek manuelne kategorije (da zarade/porez budu u grafikonu)
    const catsTop = cats.slice(0, 8);
    for (const mk of ['_payroll', '_proptax']) {
      const c = cats.find(x => x.key === mk);
      if (c && !catsTop.includes(c)) catsTop.push(c);
    }
    const agingNonZero = buckets.filter(b => b.v > 0.005);
    const charts = [
      // 1) struktura obaveza po kategoriji (donut) — center: ukupno dospelo
      { span: 1, config: donutConfig(cats.map(c => c.name), cats.map(c => +cv(c.total).toFixed(2)), { title: t('composition_by_category', lang), centerText: { value: short(cv(grand)), label: t('past_due', lang) } }) },
      // 2) iznos po kategoriji (vertikalni bar) — različite kategorije, različiti iznosi
      { span: 1, config: barConfig(catsTop.map(c => c.name), [{ label: CUR, data: catsTop.map(c => +cv(c.total).toFixed(2)), backgroundColor: SERIES.slice(0, catsTop.length), borderRadius: 4 }], { title: t('composition_by_category', lang) + ' (' + CUR + ')' }) },
      // 3) top komitenti po iznosu (horizontalni bar) — ECOR zelena
      { span: 1, config: hbarConfig(top.map(it => it.komitent), top.map(it => +cv(it.dospelo).toFixed(2)), { title: t('top_exposure', lang) }) },
      // 4) dospelo vs nedospelo (donut) — center: ukupno, legenda sa iznosima (popunjava prazan prostor)
      { span: 1, config: donutConfig([t('past_due', lang), t('upcoming', lang)], [+cv(grand).toFixed(2), +cv(nedTotal).toFixed(2)], { colors: ['#c94048', '#e0884a'], title: t('past_due', lang) + ' / ' + t('upcoming', lang), centerText: { value: short(cv(totalLia)), label: t('total', lang) }, legendValues: [money(grand) + ' ' + CUR, money(nedTotal) + ' ' + CUR] }) },
    ];
    // 5) aging po danima kašnjenja (bar, bojeno po riziku)
    if (agingNonZero.length) charts.push({ span: 1, config: barConfig(agingNonZero.map(b => b.l), [{ label: CUR, data: agingNonZero.map(b => +cv(b.v).toFixed(2)), backgroundColor: agingNonZero.map(b => b.c), borderRadius: 4 }], { title: (lang === 'en' ? 'Aging (days overdue)' : 'Kašnjenje (dana)') }) });
    // 6) predstojeća dospeća — dani do dospeća + iznos kao desna kolona
    if (up.length) charts.push({ span: 1, config: hbarConfig(up.map(it => it.komitent), up.map(it => it.minDays || 0), { title: t('due_in_days', lang), suffix: ' d', amounts: up.map(it => +cv(it.ndospelo || 0).toFixed(2)) }) });

    const tables = [];
    if (top.length) tables.push({ title: t('top_exposure', lang) + ' (' + t('past_due', lang) + ')', head: [t('komitent', lang), CUR], rows: top.map(it => [it.komitent, money(it.dospelo)]), aligns: ['left', 'right'] });
    if (up.length) tables.push({ title: t('upcoming_maturities', lang), head: [t('komitent', lang), CUR, t('due_date', lang), t('due_in_days', lang)], rows: up.map(it => [it.komitent, money(it.ndospelo), it.soonestRokStr || '—', it.minDays == null ? '—' : String(it.minDays)]), aligns: ['left', 'right', 'right', 'right'] });

    const takeaways = [];
    const pDue = totalLia > 0 ? ((grand / totalLia) * 100).toFixed(1) : '0';
    takeaways.push({ level: parseFloat(pDue) > 50 ? 'critical' : 'warn', text: t('past_due', lang) + ': ' + money(grand) + ' ' + CUR + ' (' + pDue + '% ' + t('of_total', lang) + ') · ' + t('upcoming', lang) + ': ' + money(nedTotal) + ' ' + CUR + '.' });
    if (cats[0]) takeaways.push({ level: 'info', text: t('largest_category', lang) + ': ' + cats[0].name + ' — ' + money(cats[0].total) + ' ' + CUR + ' (' + (totalLia > 0 ? ((cats[0].total / totalLia) * 100).toFixed(1) : '0') + '%).' });
    if (up[0]) takeaways.push({ level: 'warn', text: t('next_maturity', lang) + ': ' + up[0].komitent + ' — ' + (up[0].soonestRokStr || '') + ' (' + t('due_in_days', lang) + ': ' + (up[0].minDays || 0) + ').' });

    await buildDashboardPdf({
      reportTitle: t('liabilities_overview', lang),
      subtitle: t('weekly_report', lang),
      period: fmt(rp.from) + ' – ' + fmt(rp.to),
      kurs, currency: CUR, kpis, charts, tables, takeaways,
      filename: 'ECOR_Liabilities_' + isoLocal(rp.to) + '_' + lang + '.pdf',
    }, lang);
    if (state.CU) sb.rpc('log_audit', { p_user_id: state.CU.id, p_action: 'export_pdf', p_entity_type: 'nedeljni', p_entity_name: 'dashboard_pdf' }).then(null, e => console.error('SBIS:', e));
    toast('PDF (grafikoni) izvezen');
  } catch (e) { toast('Greška PDF: ' + (e.message || e), 'err'); console.error(e); } finally { hideLoading(); }
}

export async function saveReportToDb() {
  if (!state.lastReport) { toast('Generišite izveštaj prvo', 'err'); return; }
  if (!state.CU) { toast('Niste prijavljeni', 'err'); return; }
  const btn = document.querySelector('button[onclick="saveReportToDb()"]');
  if (btn) btn.disabled = true;
  showLoading();
  const rp = state.lastReport;
  try {
    const { buildExcelBase64 } = await import('./history.js');
    const result = buildExcelBase64('nedeljni');
    if (!result) { toast('Greška pri kreiranju Excel-a', 'err'); return; }
    // Build details JSON for in-app viewing — DOSPELO
    const detailsJson = [];
    for (const [key, g] of Object.entries(rp.groups)) {
      if (!g.items.length) continue;
      detailsJson.push({
        group: key === '_unk' ? 'Uncategorized' : g.meta.name_en,
        group_sr: key === '_unk' ? 'Nekategorisani' : (g.meta.name_sr || ''),
        icon: g.meta.icon || '',
        total: g.total,
        items: g.items.map(it => ({
          komitent: it.komitent,
          dospelo: it.dospelo,
          details: it.details.map(d => ({ rok: d.rok, dos: d.dos, dk: d.dk }))
        }))
      });
    }
    // Build details JSON — NEDOSPELO (još nije dospelo)
    const nedDetailsJson = [];
    if (rp.ned && rp.ned.groups) {
      for (const [key, g] of Object.entries(rp.ned.groups)) {
        if (!g.items.length) continue;
        nedDetailsJson.push({
          group: key === '_unk' ? 'Uncategorized' : g.meta.name_en,
          group_sr: key === '_unk' ? 'Nekategorisani' : (g.meta.name_sr || ''),
          icon: g.meta.icon || '',
          total: g.total,
          items: g.items.map(it => ({
            komitent: it.komitent,
            ndospelo: it.ndospelo,
            soonestRok: it.soonestRokStr || '',
            minDays: it.minDays,
            details: it.details.map(d => ({ rok: d.rok, ndos: d.ndos, days: d.days }))
          }))
        });
      }
    }
    const { data: reportId, error } = await sb.rpc('save_report', {
      p_user_id: state.CU.id, p_type: 'nedeljni',
      p_from: isoLocal(result.from),
      p_to: isoLocal(result.to),
      p_rsd: rp.totalRsd, p_usd: rp.totalUsd,
      p_kurs: rp.kurs, p_filename: result.fn, p_base64: result.b64,
      p_details: { dospelo: detailsJson, nedospelo: nedDetailsJson }
    });
    if (error) throw error;
    // Sačuvaj breakdown po kategorijama
    if (reportId) {
      const cats = [];
      for (const [key, g] of Object.entries(rp.groups)) {
        if (!g.items.length) continue;
        cats.push({
          name: key === '_unk' ? 'Uncategorized' : g.meta.name_en,
          name_sr: key === '_unk' ? 'Nekategorisani' : (g.meta.name_sr || ''),
          total: g.total,
          count: g.items.length
        });
      }
      if (cats.length) {
        try { await sb.rpc('save_report_categories', { p_report_id: reportId, p_categories: cats }); } catch (e) { console.error('SBIS:', e); }
      }
    }
    setUnsavedData(false);
    toast('Izveštaj sačuvan');
  } catch (e) { toast('Greška: ' + (e.message || e), 'err'); } finally { hideLoading(); if (btn) btn.disabled = false; }
}

export function tgGrp(i){document.getElementById('rg-'+i).classList.toggle('open')}

export function filterReportDisplay(){
  const q=(document.getElementById('rSrchInput')?.value||'').toLowerCase();
  // Kad se pretražuje, prvo proširi sve paginirane grupe ("Prikaži sve") da pretraga
  // vidi i komitente iza 50. reda (inače su van DOM-a pa ih filter ne nalazi).
  if(q){document.querySelectorAll('#rOut .rmore').forEach(b=>b.click());}
  document.querySelectorAll('#rOut .rkr').forEach(row=>{
    const name=row.querySelector('.rkn')?.textContent?.toLowerCase()||'';
    row.style.display=(!q||name.includes(q))?'':'none';
  });
}

// PERIOD COMPARISON — works with parsedData if available, otherwise warns
export function showCompare(){
  if(!state.lastReport){toast('Generišite izveštaj prvo','err');return;}
  if(!parsedData.length){toast('Nema podataka za prethodni period u memoriji. Učitajte Excel fajl sa podacima za oba perioda.','warn');return;}
  // Current period is lastReport
  const cur=state.lastReport;
  // Calculate previous period (same duration, shifted back).
  // Računaj u kalendarskim danima (date-part aritmetika) — fiksno oduzimanje ms pomeri granice
  // sa ponoći pri prelasku na/sa letnjeg računanja vremena i tiho izbaci jedan dan iz poređenja.
  const dayCount=Math.round((cur.to.getTime()-cur.from.getTime())/86400000)+1;
  const prevTo=new Date(cur.from.getFullYear(),cur.from.getMonth(),cur.from.getDate()-1);
  const prevFrom=new Date(prevTo.getFullYear(),prevTo.getMonth(),prevTo.getDate()-(dayCount-1));
  const kurs=cur.kurs;
  const extractSifra=s=>{const m=(s||'').match(/^\s*(\d+)\s+/);return m?m[1]:null};
  const normBody=s=>{let x=(s||'').toLowerCase().replace(/[\xa0\u200b]/g,' ').replace(/\s+/g,' ').trim();const m=x.match(/^\d+\s+(.+)$/);return m?m[1]:x};
  const bySifra={},byBody={};
  for(const k of state.komData){const vr=state.vrsteData.find(v=>v.id===k.vrsta_troska_id);if(!vr)continue;const s=extractSifra(k.name);if(s)bySifra[s]=vr.name_en;byBody[normBody(k.name)]=vr.name_en;}
  const lookupKom=name=>{const s=extractSifra(name);if(s&&bySifra[s])return bySifra[s];return byBody[normBody(name)]||null};

  // Build previous period data
  const amt=d=>(d.dos||0)+(d.ndos||0);
  const prevFiltered=[];
  for(const k of parsedData){
    const md=k.details.filter(d=>{if(d._virtual)return true;if(!d.rok)return false;const rd=pDate(d.rok);return rd&&rd>=prevFrom&&rd<=prevTo;});
    if(md.length>0){const dospelo=md.reduce((s,d)=>s+amt(d),0);prevFiltered.push({...k,details:md,total:dospelo,dospelo});}
  }

  const prevGroups={};for(const v of state.vrsteData)prevGroups[v.name_en]={total:0,count:0};prevGroups['_unk']={total:0,count:0};
  for(const k of prevFiltered){const vt=lookupKom(k.komitent)||'_unk';const key=prevGroups[vt]?vt:'_unk';prevGroups[key].total+=k.dospelo;prevGroups[key].count++;}

  const curGroups={};
  for(const[key,g] of Object.entries(cur.groups)){curGroups[key]={total:g.total,count:g.items.length,meta:g.meta};}

  const fmt=d=>d.toLocaleDateString('sr-RS');
  const out=document.getElementById('compareOut');
  out.style.display='block';
  out.textContent='';

  // Header
  const hdr=document.createElement('div');hdr.className='card';hdr.style.cssText='margin-bottom:16px;padding:18px';
  const h2=document.createElement('h2');h2.style.cssText='font-size:16px;margin-bottom:12px;color:var(--acc)';h2.appendChild(svgIcon('chart',16));h2.appendChild(document.createTextNode(' Uporedni pregled'));
  const sub=document.createElement('div');sub.style.cssText='font-size:13px;color:var(--tx3)';
  sub.textContent='Teku\u0107i: '+fmt(cur.from)+' \u2013 '+fmt(cur.to)+' | Prethodni: '+fmt(prevFrom)+' \u2013 '+fmt(prevTo);
  hdr.appendChild(h2);hdr.appendChild(sub);out.appendChild(hdr);

  // Comparison table
  const card=document.createElement('div');card.className='card';card.style.cssText='padding:0;overflow:hidden';
  const tbl=document.createElement('table');tbl.className='dtbl';
  const thead=document.createElement('thead');
  const tr=document.createElement('tr');
  ['Kategorija','Teku\u0107i (RSD)','Prethodni (RSD)','Promena (RSD)','Promena (%)'].forEach(h=>{
    const th=document.createElement('th');th.textContent=h;tr.appendChild(th);
  });
  thead.appendChild(tr);tbl.appendChild(thead);

  const tbody=document.createElement('tbody');
  let totalCur=0,totalPrev=0;

  for(const[key,cg] of Object.entries(curGroups)){
    if(cg.meta&&cg.meta._manual)continue; // sintetičke (zarade/porez) nemaju prethodni period — isključi iz poređenja
    if(!cg.count&&!(prevGroups[key]&&prevGroups[key].count))continue;
    const pg=prevGroups[key]||{total:0,count:0};
    const delta=cg.total-pg.total;
    const pct=pg.total?((delta/Math.abs(pg.total))*100):(cg.total>0?100:cg.total<0?-100:0);
    totalCur+=cg.total;totalPrev+=pg.total;

    const row=document.createElement('tr');
    const td1=document.createElement('td');td1.style.fontWeight='600';td1.textContent=(cg.meta?.icon||'')+' '+(key==='_unk'?'Nepoznati':(cg.meta?.name_en||key));
    const td2=document.createElement('td');td2.style.cssText='text-align:right;font-family:var(--mn)';td2.textContent=fNum(cg.total);
    const td3=document.createElement('td');td3.style.cssText='text-align:right;font-family:var(--mn);color:var(--tx2)';td3.textContent=fNum(pg.total);
    const td4=document.createElement('td');td4.style.cssText='text-align:right;font-family:var(--mn);font-weight:600;color:'+(delta>0?'var(--dng)':delta<0?'var(--suc)':'var(--tx3)');td4.textContent=(delta>0?'+':'')+fNum(delta);
    const td5=document.createElement('td');td5.style.cssText='text-align:right;font-family:var(--mn);color:'+(pct>0?'var(--dng)':pct<0?'var(--suc)':'var(--tx3)');td5.textContent=(pct>0?'+':'')+pct.toFixed(1)+'%';
    row.appendChild(td1);row.appendChild(td2);row.appendChild(td3);row.appendChild(td4);row.appendChild(td5);
    tbody.appendChild(row);
  }

  // Total row
  const totalDelta=totalCur-totalPrev;
  const totalPct=totalPrev?((totalDelta/Math.abs(totalPrev))*100):(totalCur>0?100:totalCur<0?-100:0);
  const trow=document.createElement('tr');trow.style.cssText='background:var(--surface);font-weight:700';
  const tt1=document.createElement('td');tt1.textContent='UKUPNO';
  const tt2=document.createElement('td');tt2.style.cssText='text-align:right;font-family:var(--mn)';tt2.textContent=fNum(totalCur);
  const tt3=document.createElement('td');tt3.style.cssText='text-align:right;font-family:var(--mn)';tt3.textContent=fNum(totalPrev);
  const tt4=document.createElement('td');tt4.style.cssText='text-align:right;font-family:var(--mn);color:'+(totalDelta>0?'var(--dng)':totalDelta<0?'var(--suc)':'var(--tx3)');tt4.textContent=(totalDelta>0?'+':'')+fNum(totalDelta);
  const tt5=document.createElement('td');tt5.style.cssText='text-align:right;font-family:var(--mn);color:'+(totalPct>0?'var(--dng)':totalPct<0?'var(--suc)':'var(--tx3)');tt5.textContent=(totalPct>0?'+':'')+totalPct.toFixed(1)+'%';
  trow.appendChild(tt1);trow.appendChild(tt2);trow.appendChild(tt3);trow.appendChild(tt4);trow.appendChild(tt5);
  tbody.appendChild(trow);

  tbl.appendChild(tbody);card.appendChild(tbl);out.appendChild(card);

  if(!prevFiltered.length){
    const note=document.createElement('div');note.style.cssText='padding:14px;color:var(--warn);font-size:13px';note.textContent='\u26A0 Nema podataka za prethodni period ('+fmt(prevFrom)+' \u2013 '+fmt(prevTo)+'). Proverite da Excel sadr\u017ei podatke za oba perioda.';
    out.appendChild(note);
  }
}
